import {Box, Typography, Theme, Link} from '@mui/material'
import React, {FC} from 'react'
import {useTranslation} from 'react-i18next'
import {Link as RouterLink} from 'react-router'

import {FEATURE_NAMESPACE} from '../../consts'
import {usePlantUpmId, usePomNavigation} from '../../hooks'
import {ActionItem} from '../../types'

type ActionConnectedToSectionProps = {
  action: ActionItem
}

export const ActionConnectedToSectionLink: FC<ActionConnectedToSectionProps> = ({action}) => {
  const {section, topic, questionId} = action
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const plantId = usePlantUpmId()
  const nav = usePomNavigation()

  return (
    <Box data-test-id="action-connected-to-link" pb={3}>
      <Typography
        sx={(theme: Theme) => ({
          color: theme.palette.grey[600]
        })}
        variant="caption"
        display="flex"
      >
        {t('actionDialog.connectedTo')}
      </Typography>
      <Link
        component={RouterLink}
        to={{
          pathname: nav.buildSubSectionPath(plantId, section?.id ?? '', topic?.id ?? ''),
          search: `?selectedQuestionId=${questionId}`
        }}
        sx={{textDecoration: 'none', fontWeight: 600}}
      >
        {questionId}
      </Link>
    </Box>
  )
}
